module.exports = __webpack_public_path__ + "img/health_bg.6c9b34fa.png";